import React from 'react';
import { Box, Button } from '@mui/material';

interface StepActionsProps {
    onComplete?: () => void;
    onCancel?: () => void;
    completeLabel?: string;
    cancelLabel?: string;
    completeDisabled?: boolean;
    completeColor?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
    showCancel?: boolean;
}

const StepActions: React.FC<StepActionsProps> = ({
    onComplete,
    onCancel,
    completeLabel = 'Continue',
    cancelLabel = 'Cancel',
    completeDisabled = false,
    completeColor = 'primary',
    showCancel = true
}) => {
    return (
        <Box sx={{ mt: 2, display: 'flex', gap: 2, justifyContent: 'space-between' }}>
            {showCancel && onCancel && (
                <Button variant="outlined" onClick={onCancel}>
                    {cancelLabel}
                </Button>
            )}
            {onComplete && (
                <Button
                    variant="contained"
                    color={completeColor}
                    onClick={onComplete}
                    disabled={completeDisabled}
                    sx={{ ml: showCancel ? 0 : 'auto' }}
                >
                    {completeLabel}
                </Button>
            )}
        </Box>
    );
};

export default StepActions;
